module.exports = __webpack_public_path__ + "img/Tick-Icon.e8cbd2b7.svg";